import React from 'react'
import {Card, Col, Row} from 'react-bootstrap'
import {PaymentActivityData} from './PaymentActivitydata'
import {useTranslation} from "react-i18next";

const PaymentActivity = (props: any) => {
    const {t} = useTranslation();
    const {totalAmount, saleAmounts, saleDates} = props;
    return (
        <React.Fragment>
            <Col xs={12} md={8}>
                <Card>
                    <Card.Header className="border-0 align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">{t('Dashboard.total_amount')}</h4>
                    </Card.Header>
                    <Card.Body className="py-1">
                        <Row className="gy-2">
                            <Col md={12}>
                                <h4 className="fs-22 mb-0">
                                    {typeof totalAmount === 'number' 
                                        ? totalAmount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                        : totalAmount} TL
                                </h4>
                            </Col>
                        </Row>
                        {
                            saleAmounts && saleDates &&  <PaymentActivityData
                                categories={saleDates}
                                data={saleAmounts}
                                className="apex-charts"
                                dataColors='["--in-primary", "--in-light"]'/>
                        }

                    </Card.Body>
                </Card>
            </Col>

        </React.Fragment>
    )
}

export default PaymentActivity
